module.exports = __webpack_public_path__ + "media/images/pc/stores/common/appeal_03-4a6f7eb9ab9964f9a67c085dc6ba0532.jpg";